import React, { useContext, useState, useEffect, useRef, useCallback } from 'react';
import { useMedia } from 'react-use';
import { Modal, Button } from 'ck-ui';
import { BundleLookPageContext } from '../context';
import { BundleLookModal } from './BundleLookModal';
import styles from './AddBundleToCart.module.scss';

const BundleLookModalToggle = () => {
  const byoBundlePageContext = useContext(BundleLookPageContext);
  const isMobile = useMedia('(max-width: 767px)');
  const { current } = useRef(byoBundlePageContext);
  const [show, setShow] = useState(false);
  const open = useCallback(() => setShow(true), []);
  const close = useCallback(() => setShow(false), []);
  const { addedCount, bundle } = byoBundlePageContext;
  const hasAddedAll = bundle && bundle.totalCount === addedCount;

  useEffect(() => {
    if (current.bundle && current.bundle.totalCount !== current.addedCount && hasAddedAll) {
      setShow(hasAddedAll);
    }
  }, [current, hasAddedAll]);

  const buttonText = bundle ? 'BUNDLE' : 'LOOK';

  return (
    <>
      <Button
        disabled={addedCount === 0}
        size={isMobile ? null : 'large'}
        fullwidth="mobile"
        className={styles.viewBundle}
        onClick={open}
      >{ isMobile ? `VIEW ${buttonText}` : `VIEW YOUR ${buttonText}`} ({addedCount}{bundle && `/${bundle.totalCount}`})
      </Button>
      <Modal show={show} onClose={close} isAdaptive>
        <BundleLookModal onClose={close} />
      </Modal>
    </>
  );
};

export { BundleLookModalToggle };
